// extracted by mini-css-extract-plugin
export default {"title":"ee27c96c12","bld":"_5ca505e886"};